import { AxiosError } from 'axios';
import { apiPost } from './api';
import { ICreateNewCity } from '../types/OpsSupport';
const { REACT_APP_ORGANIZATION } = process.env;

export const createNewCity = async (body: ICreateNewCity): Promise<string> => {
  return apiPost(`${REACT_APP_ORGANIZATION}/city`, body).then(response =>
    Promise.resolve(response).catch((error: AxiosError) => Promise.reject(error))
  );
};
